import {Observable} from 'rxjs';
import {jobHunterAPI, RestQueryParams} from 'jobhunter-common-web';

export function addOfferToObservedAPI(authToken: string | null, offerId: string): Observable<any> {
    let headers = undefined;
    if (authToken) {
        headers = {
            Authorization: `Bearer ${authToken}`,
        };
    }

    return jobHunterAPI.put(`api/offers/${offerId}/add_to_observed`, {}, new RestQueryParams(), headers);
}
